import React from "react";
import { Box, Divider, Typography } from "@mui/material";
import StatusItem from "./StatusItem";
import { useTranslation } from "react-i18next";

function StatusItems({ order }) {
  const { t } = useTranslation();

  const hasReturnOnDeliveryStatuses = order.returnStatusChanges.length > 0;

  return (
    <Box>
      {/* Return on delivery statuses */}
      {hasReturnOnDeliveryStatuses && (
        <>
          <Typography className={"my-2 ms-14 md:text-gray-500 smMax:ms-5 smMax:font-bold"}>
            {t("orderTracking.returnOnDeliveryStatus")}
          </Typography>
          <Divider className={"mx-auto mb-2 w-[93%] smMax:hidden"} />
          {order.returnStatusChanges
            .slice()
            .reverse()
            .map((statusItem, index) => (
              <StatusItem key={index} statusItem={statusItem} />
            ))}
        </>
      )}

      {/* Delivery statuses */}
      {hasReturnOnDeliveryStatuses && (
        <>
          <Typography className={"my-2 ms-14 md:text-gray-500 smMax:ms-5 smMax:font-bold"}>
            {t("orderTracking.deliveryStatus")}
          </Typography>
          <Divider className={"mx-auto mb-2 w-[93%] smMax:hidden"} />
        </>
      )}
      {order.statusChanges
        .slice()
        .reverse()
        .map((statusItem, index) => (
          <StatusItem key={index} statusItem={statusItem} />
        ))}
    </Box>
  );
}

export default StatusItems;
